import { render, staticRenderFns } from "./StyleNew.vue?vue&type=template&id=1fe26589&scoped=true&"
import script from "./StyleNew.vue?vue&type=script&lang=js&"
export * from "./StyleNew.vue?vue&type=script&lang=js&"
import style0 from "./StyleNew.vue?vue&type=style&index=0&id=1fe26589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe26589",
  null
  
)

export default component.exports